<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="cover">
<figure class="img90" id="cover-image"><img alt="Lights, Camera, Danger (Alien Superstar #2)" src="images/9781683358640.jpg"/>
<figcaption></figcaption>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?16e907dd